import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings";
import MAIMotionVideo from "../../videos/MAIMotion.mp4";

const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)``;
const Subheading = tw(SubheadingBase)`text-center mb-3`;
const Description = tw.p`mt-4 mx-auto text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 text-center`;

const Cards = tw.div`mt-16 flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-6xl mx-auto`;
const StyledVideo = tw.video`w-full h-auto block`;
const StyledIframe = tw.iframe`w-full aspect-video rounded-lg border-0`;
const FullWidthCardContainer = tw.div`w-full flex flex-col min-h-full p-2`;
const OneThirdCardContainer = tw.div`w-full sm:w-1/2 lg:w-1/3 flex flex-col min-h-full p-2`;

export default ({
  heading = "Meet These Fine Folks",
  subheading = "",
  description = "",
  cards = [],
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => {
            const isFirst = index === 0;
            const CardWrapper = isFirst ? FullWidthCardContainer : OneThirdCardContainer;

            return (
                <CardWrapper key={index}>
                  {card.includes("youtube.com") ? (
                      <StyledIframe
                          src={card.replace("watch?v=", "embed/").replace("/shorts/", "/embed/")}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                      />
                  ) : (
                      <StyledVideo preload="auto" loop muted controls playsInline>
                        <source src={card} type="video/mp4" />
                      </StyledVideo>
                  )}
                </CardWrapper>
            );
          })}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
